export default "__VITE_ASSET__CUJka0Eg__"